import { useEffect, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, actions } from 'builder/modules/resumeEditor'
import { useTailoredDesignation } from 'builder/hooks/useTailoredDesignation'
import { Props } from '../types'
import { ANALYTICS_SECTION_NAME } from '../../../constants'

export const useGenerateWithTailoredRole = (props: Props) => {
  const { currentWorkExperience } = props
  const { recommendedJobTitle, employerName } = useTypedSelector(selectors.jobPostingAPIData)
  const tailoredDesignation = useTailoredDesignation(recommendedJobTitle, employerName)
  const { includeJobPosting } = useTypedSelector(selectors.aiWorkExperience)
  const GenerateWithTailoredRoleRef = useRef<HTMLDivElement | null>(null)
  const dispatch = useDispatch()
  const workExperienceId = currentWorkExperience.id

  const handleClose = () => {
    dispatch(actions.setIsAiWorkExperienceWithTailoredResumeModalOpen(false))
  }

  useEffect(() => {
    if (tailoredDesignation) {
      trackInternalEvent('open_ai_writer_tailored_dialog', {
        section: ANALYTICS_SECTION_NAME,
      })
    }
  }, [tailoredDesignation])

  useEffect(() => {
    dispatch(actions.setIsIncludeJobPostingToAiWorkExperience(true))
  }, [dispatch])

  const handleSelectOption = useCallback(
    (value: boolean) => {
      dispatch(actions.setIsIncludeJobPostingToAiWorkExperience(value))
    },
    [dispatch],
  )

  const handleGenerate = useCallback(() => {
    dispatch(actions.setIsAiWorkExperienceWithTailoredResumeModalOpen(false))
    dispatch(actions.generateResumeAiWorkExperience({ workExperienceId }))
    trackInternalEvent('click_generate', {
      label: 'ai_writer_tailored_dialog',
      section: ANALYTICS_SECTION_NAME,
      position_selected: includeJobPosting,
    })
  }, [dispatch, includeJobPosting, workExperienceId])

  return {
    tailoredDesignation,
    GenerateWithTailoredRoleRef,
    includeJobPosting,
    handleClose,
    handleSelectOption,
    handleGenerate,
  }
}
